// src/mixins/index.js
import alerts from './alert'

// Exporta todos los mixins que quieras hacer globales
export { alerts }

// Opcional: Instalación global automática
export default {
  install(Vue) {
    // Registra los mixins globalmente
    Vue.mixin(alerts)
  }
}